import MenuItem from '@mui/material/MenuItem';
import Pagination from '@mui/material/Pagination';
import TextField from '@mui/material/TextField';
import {
  DataGrid,
  gridPageCountSelector,
  gridPageSelector,
  gridPageSizeSelector,
  gridPaginationRowCountSelector,
  gridPaginationRowRangeSelector,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid';
import React, { useCallback, useMemo } from "react";

const pageSizeOption = [
  {
    value: '5',
    label: '5',
  },
  {
    value: '10',
    label: '10',
  },
  {
    value: '15',
    label: '15',
  },
  {
    value: '20',
    label: '20',
  },
  {
    value: '50',
    label: '50',
  },
  {
    value: '100',
    label: '100',
  }
];



function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  const pageRange = useGridSelector(apiRef, gridPaginationRowRangeSelector);

  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const RowCount = useGridSelector(apiRef, gridPaginationRowCountSelector);

  // const itemCount = useGridSelector(apiRef, gridItemCountSelector);

  return (
    <div className='flex  px-4 items-center'>
      <div className='text-[#4C4E64]/[0.67] font-normal mr-4'>จำนวนรายการต่อหน้า</div>
      <div className='mr-4'>


        <TextField
          id=""
          select
          label=""
          defaultValue="5"
          onChange={(e) => {
            apiRef.current.setPageSize(e.target.value)
          }}
          size='small'
          slotProps={{ input:{
            sx:{fieldset:{border:0},'.MuiInputBase-input':{fontSize:'14px',color:"#4C4E64DE"}}
          }}}
     
        >
          {pageSizeOption.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

      </div>

      <div className='text-[#4C4E64]/[0.67] font-normal mr-4'>{pageRange && pageRange.firstRowIndex + 1}-{pageRange && pageRange.lastRowIndex + 1} of {RowCount}</div>

      <Pagination
        sx={(theme) => ({ padding: theme.spacing(1.5, 0), '.MuiPaginationItem-root.Mui-selected': { backgroundColor: "#2DC76D", color: "#FFF" } })}

        count={pageCount}
        page={page + 1}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    </div>
  );
}

export const AllderTable = React.memo(function AllderTable({
  getRowId ,
  rows,
  columns,
  customStyles,
  checkboxSelection=true,
  onRowModelChange=false,
  columnVisibilityModel={},
  selectionModel,
  loading,
  isRowSelectable,
  ...props
}) {


  const getRowHeight = useCallback(() => "auto", []);


  const styles = useMemo(
      () => ({
        fontFamily: "Sarabun",
        fontSize: "14px",
        ".MuiDataGrid-columnHeaderTitle": {
          fontFamily: "Sarabun",
          fontSize: "14px",
        },
        ".MuiDataGrid-cell": {
          display: "flex",
          alignItems: "center",
          paddingTop: "5px",
          paddingBottom: "5px",
        },
        '&.MuiDataGrid-columnHeaderRow':{
                        height:'46px !important'
                    },
        ...customStyles,
      }),
      [customStyles]
  );


  return (
        <DataGrid
            getRowId={getRowId}
            getRowHeight={getRowHeight}
            rows={rows}
            columns={columns}
            initialState={{
            pagination: {
                paginationModel: {
                pageSize: 10,
                },
            },
            }}
            pageSizeOptions={[10]}
            checkboxSelection={checkboxSelection}
            disableRowSelectionOnClick
            slots={{
                pagination: CustomPagination,
            }}
            sx={styles}
            onRowSelectionModelChange={(val) => {
              onRowModelChange(val)
            }}
            columnVisibilityModel={columnVisibilityModel}
            rowSelectionModel={selectionModel}
            loading={loading}
            isRowSelectable={isRowSelectable}
        />
    )



});

AllderTable.displayName = "AllderTable";

export default AllderTable;
